import { useState } from "react";

import { useResponsive } from "@design-lab/shared/hooks/useResponsive";
import { useTokenManagement } from "../../../model/tokenManagement";
import { useRequestMoreCredits } from "../../../model/useRequestMoreCredits";
import { HelpModal } from "../HelpModal";
import { HelpTooltip } from "../HelpTooltip";
import { QuestionMarkIcon } from "../icons";
import { RequestMoreTooltip } from "./RequestMoreTooltip";

type CreditsHeaderProps = {
  labelText?: string;
  labelHtmlFor?: string;
  helpTestId?: string;
};

export function CreditsHeader({
  labelText = "Your prompt",
  labelHtmlFor = "prompt",
  helpTestId = "help-trigger"
}: CreditsHeaderProps) {
  const { isDesktop } = useResponsive();
  const { aiCreditsBalance } = useTokenManagement();
  const [isHelpModalOpen, setIsHelpModalOpen] = useState(false);
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  const { handleRequestMore } = useRequestMoreCredits({
    deviceType: isDesktop ? "desktop" : "mobile"
  });

  const handleRequestMoreClick = () => {
    if (!isTooltipOpen) {
      handleRequestMore();
    }
    setIsTooltipOpen(!isTooltipOpen);
  };

  return (
    <>
      <div className="mb-1 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <label
            htmlFor={labelHtmlFor}
            className="h-full text-sm font-semibold text-gray-700"
            data-testid="prompt-label"
          >
            {labelText}
          </label>
          <div
            className={`text-sm font-bold ${aiCreditsBalance > 0 ? "text-cta-gradient" : "text-gray-400"}`}
            data-testid="credits-count"
          >
            {aiCreditsBalance}/5 remaining today
          </div>
          {aiCreditsBalance === 0 && (
            <RequestMoreTooltip
              isOpen={isTooltipOpen}
              onToggle={handleRequestMoreClick}
              onClose={() => setIsTooltipOpen(false)}
            />
          )}
        </div>

        {isDesktop ? (
          <HelpTooltip />
        ) : (
          <button onClick={() => setIsHelpModalOpen(true)} data-testid={helpTestId}>
            <QuestionMarkIcon className="size-5" />
          </button>
        )}
      </div>

      <HelpModal isOpen={isHelpModalOpen} onClose={() => setIsHelpModalOpen(false)} />
    </>
  );
}
